import { getFunctions, connectFunctionsEmulator, Functions } from '@angular/fire/functions';
import { environment } from '../../environments/environment';

export function functionsFactory(): () => Functions {
  return () => {
    const functions = getFunctions(); // Initialisiert Functions
    if ('useEmulators' in environment && environment.useEmulators) {
      connectFunctionsEmulator(functions, 'localhost', 5001);
    }
    return functions;
  };
}
